module.exports = __webpack_public_path__ + "assets/e21aadc756aa4d06fea44b3245a54f0b.mp3";